// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"
import { urlQueryBuilder } from "~utils/utils"

// Services
import CompanyContactService from "~services/CompanyContactService"

// Shapes
import {
  CompanyShape,
  PostCompanyShape,
  GetCompanyOptionsShape,
} from "~shapes/company"

const CompanyService = {
  getCompany: async (id: string) => {
    const companiesUrl = `${Endpoints.COMPANIES.URL}/${id}`
    const response = await Api.get(companiesUrl)
    return response.data
  },
  getCompanyWithLocation: async (id: string) => {
    const companiesUrl = `${Endpoints.COMPANIES.URL}/${id}?projection=includeLocation`
    try {
      const response = await Api.get(companiesUrl)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }

    // const contactsResponse = await CompanyContactService.getContacts(id)

    // return { ...company, contacts: contactsResponse._embedded.contacts }
  },
  getCompanies: async (options?: GetCompanyOptionsShape) => {
    let companiesUrl = Endpoints.COMPANIES.URL

    if (options) {
      const query = urlQueryBuilder(options)
      companiesUrl = `${companiesUrl}?${query}`
    }

    const response = await Api.get(companiesUrl)
    const { data } = response

    return data
  },
  getCompaniesWithLocation: async (options?: GetCompanyOptionsShape) => {
    let companiesUrl = `${Endpoints.COMPANIES.URL}?projection=includeLocation`

    if (options) {
      const query = urlQueryBuilder(options)
      companiesUrl = `${companiesUrl}&${query}`
    }

    const response = await Api.get(companiesUrl)
    const { data } = response

    return data
  },
  postCompany: async (company: PostCompanyShape) => {
    const companiesUrl = Endpoints.COMPANIES.URL
    const response = await Api.post(companiesUrl, company)
    return response.data
  },
  patchCompany: async (company: Partial<CompanyShape>) => {
    const { id, ...rest } = company

    const companiesUrl = `${Endpoints.COMPANIES.URL}/${id}`
    const response = await Api.patch(companiesUrl, rest)
    return response.data
  },
}

export default CompanyService
